import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit {
  color = 'primary';
  value = 50;
  isLoading: Subject<boolean> = this.loader.isLoading;
  constructor(private loader: LoaderService) {}

  ngOnInit(): void {}
}
